module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d70269b2caad2491ee6da299fbf75e72.gif";